import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewPNDataFormValues } from '@e-origin/contracts';

import { TextInput } from '@components';

interface TSDPNCarrierSectionProps {
  form: UseFormReturnType<TSDViewPNDataFormValues>;
  disabled: boolean;
}

export const TSDPNCarrierSection: React.FC<TSDPNCarrierSectionProps> = ({ form, disabled }) => {
  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Carrier
      </Title>

      <Grid>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('carrier.name')} label="Carrier name" disabled={disabled} />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput {...form.getInputProps('carrier.identificationNumber')} label="Carrier identification" disabled={disabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
